import React from 'react'
import { Link } from 'react-router-dom'
import FontAwesome from 'react-fontawesome'
import 'font-awesome/css/font-awesome.css'

const Header = () => (
  <header>
    <nav>
      <div className="header">
        <div className="header_image_div"><img className="header_image" src="/meeple-logo.png" alt="Meeples"/><br/></div>
        <Link to='/'><button className="header_button">Activity Feed</button></Link>
        <Link to='/profile'><button className="header_button">Profile</button></Link>
        <Link to='/about'><button className="header_button">About</button></Link>
        <Link to='/newevent'><button className="header_button">New Event</button></Link>
        <Link to='/google'><button className="header_button"><FontAwesome name="google"/> Google</button></Link>
        <Link to='/facebook'><button className="header_button"><FontAwesome name="facebook"/> Facebook</button></Link>
      </div>
    </nav>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js